export default "__VITE_ASSET__ad8d09df__"